import {Controller} from "stimulus"

export default class extends Controller {
  connect() {
      if ($("#web_applicant_veteran_true").is(':checked') == true) {
          $( "#vetsection" ).show();
      } else {
          $( "#vetsection" ).hide();
      };
  }
    yesveteran() {
       if (event.target.value == "true") {
         $( "#vetsection" ).show();
        }
    }

    noveteran() {
       if (event.target.value == "false") {
         $( "#vetsection" ).hide();
        }
    }



  }
